import { render, staticRenderFns } from "./CytomineMultiselect.vue?vue&type=template&id=1187e655&"
import script from "./CytomineMultiselect.vue?vue&type=script&lang=js&"
export * from "./CytomineMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./CytomineMultiselect.vue?vue&type=style&index=0&id=1187e655&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports